module.exports = __webpack_public_path__ + "static/media/proximanova-semibold-webfont.791adc40.woff";